<template>
  <div
    class="spnod-admin__form--container container mx-0 w-100"
    :class="isMobile ? 'px-0' : 'px-3'">
    <b-form @submit.stop.prevent="handleSubmit">
      <b-form-group class="mb-3">
        <b-form-input
          name="email"
          v-model="$v.form.email.$model"
          :state="validateState('email')"
          type="text"
          placeholder="Email"
          size="sm"
          class="mb-2"
        ></b-form-input>
        <b-form-input
          name="phone"
          v-model="$v.form.phone.$model"
          :state="validateState('phone')"
          type="text"
          placeholder="Phone Number"
          size="sm"
          class="mb-2"
        ></b-form-input>
        <div v-if="form.error !== ''">{{ this.form.error }}</div>
      </b-form-group>
      <b-form-group class="d-flex justify-content-end">
        <b-button class="spnod-admin__form--button" type="submit" size="sm" :disabled="isDisabled">
          <p v-if="!isSending">Send</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ResendCodeForm',
  mixin: [validationMixin],
  data() {
    return {
      form: {
        isAdmin: true,
        email: '',
        phone: '',
        error: ''
      },
      isSending: false
    }
  },
  computed: {
    ...mapGetters(['signedUp', 'verifyError']),
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some((arr) => {
        return arr[1] === '' && arr[0] !== 'error'
      })
      return anyBlanks || this.$v.form.$anyError
    },
    isMobile() { return window.innerWidth <= 768 }
  },
  methods: {
    ...mapActions(['doResendCode']),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async resendCode (model) {
      try {
        this.isSending = true
        await this.doResendCode(model)
        this.$router.push('/verify')
      } catch (err) {
        console.log(err)
      }
    },
    handleSubmit: function (e) {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.resendCode(this.form)
    }
  },
  validations: {
    form: {
      email: { required, email },
      phone: { required, isTenDigits: (number) => number.length === 10 },
      error: {}
    }
  },
  watch: {
    verifyError: function (newVal, oldVal) {
      if (newVal !== '') {
        this.form.error = newVal
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/ResendCodeForm.vue?555896a8